export default "__VITE_ASSET__BZsF0MkT__"